<template>
  <div class="content add-post-wrap">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-9 d-post-preview-wrap">
          <div v-if="post" class="d-block d-post-preview">
            <div class="post-media post-image">
              <img v-if="post.type === 'image'" :src="post.url" :alt="post.title">

              <iframe v-if="post.type === 'video' && youtubeId" :src="`https://www.youtube.com/embed/${youtubeId}`"
                      frameborder="0"
                      allowfullscreen></iframe>

              <video v-if="post.type === 'video' && !youtubeId" width="100%" controls>
                <source :src="post.url" type="video/mp4">
              </video>

            </div>
            <div class="post-content">
              <h1>{{post.title}}</h1>
              <div class="post-text" v-html="post.body"></div>
              <div>
                <router-link class="btn btn-edit"
                             :to="{name: 'impactPostEdit', params: {postId: post.feedback_id}}"
                >Edit Post
                </router-link>
                <a v-if="activeCharityInfo"
                   :href="`${config.donor_next_scheme}://${activeCharityInfo.subdomain}.${config.donor_next_url}/posts/${post.feedback_id}`"
                   target="_blank"
                   class="btn btn-sm">View Post</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="d-block info-card need-help">
            <h3 class="info-card-title">Want some help with Impact Posts?</h3>
            <p class="info-card-text">Check out our tips and best practices for creating the best possible post</p>
            <a href="https://help.harnessgiving.com/en/collections/2016433-impact-posts" class="btn btn-sm">Go to Articles</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getPost} from '../../utils/api';
  import {getYoutubeId} from '../../utils/video';
  import config from '../../../public/harness_config.json';
  import {mapState} from "vuex";

  export default {
    name: 'ImpactPost',
    metaInfo() {
      return {
        title: 'Post - ' + (this.post ? this.post.title : ''),
      }
    },
    mounted() {
      getPost(this.$route.params.postId).then(post => {
        this.post = post;
      }).catch(() => {
        this.$router.push('/impact-posts');
      });
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      youtubeId() {
        return getYoutubeId(this.post.url);
      },
      config() {
        return config;
      },
    },
    watch: {
      'activeCharityId'() {
        this.$router.push('/impact-posts');
      },
    },
    data() {
      return {
        post: null,
      };
    },
  };
</script>
<style lang="sass" scoped>
  .post-text
    white-space: pre-wrap
</style>
